<template>
    <div v-if="facet.name" class="card border-0 filter-card pt-0 mb-1" :class="facet.cssClass">
		<div class="card-header p-0">
			<button class="btn  collapsed d-block btn-header text-left p-0" type="button" data-toggle="collapse" :data-target="'#collapse'+'_'+ facetName.replace(/ /g,'_')" aria-expanded="false" :aria-controls="'collapse'+'_'+ facetName">
				<i class="fa fa-chevron-down pull-right"></i>
				{{ facetName }}
			</button>
		</div>

		<div v-if="facet.type === 'price'" class="collapse" :id="'collapse'+'_'+ facetName.replace(/ /g,'_')">
			<item-filter-price></item-filter-price>
		</div>

		<ul v-else class="card-body collapse list-group list-group-flush p-0" :id="'collapse'+'_'+ facetName.replace(/ /g,'_')">
			<li class="list-group-item p-1 c-pointer" v-for="value in facets" :key="value.id" :class="value.cssClass">
				<label :for="'option-' + value.id + '-' + _uid" class="form-check-label c-pointer" :class="[paddingClasses, isSelected(value.id) ? 'bg-appearance' : '', 'option-' + value.id]" :style="paddingInlineStyles">
					<div class="d-flex">
						<input :id="'option-' + value.id + '-' + _uid" class="form-check-input mr-2 c-pointer flex-shrink-0" type="checkbox" :checked="isSelected(value.id)" @change="updateFacet(value)" :disabled="isLoading || value.count <= 0">
						<div class="flex-grow-1">{{ value.name }}</div>
						<div class="filter-color t3"></div>
						<div class="filter-badge">{{ value.count }}</div>
					</div>
				</label>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilterPrice from "./ItemFilterPrice.vue";

export default {

    name: "item-filter",

    components:
    {
        ItemFilterPrice
    },

    props:
    {
        facet:
        {
            type: Object
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    computed:
    {
        facets()
        {
            return this.facet.values;
        },

        facetName()
        {
            if (this.facet.translationKey && this.facet.translationKey.length > 0)
            {
                return this.$translate("Ceres::Template." + this.facet.translationKey);
            }

            return this.facet.name;
        },

        ...mapState({
            selectedFacets: state => state.itemList.selectedFacets,
            isLoading: state => state.itemList.isLoading
        })
    },

    methods:
    {
        updateFacet(facetValue)
        {
            const toolbarElements = document.getElementsByClassName("widget-toolbar");

            for (const toolbarElement of toolbarElements)
            {
                if (toolbarElement.contains(this.$vnode.elm))
                {
                    window.localStorage.setItem("openFilterToolbar", true);
                }
            }

            this.$store.dispatch("selectFacet", { facetValue });
        },

        isSelected(facetValueId)
        {
            return this.selectedFacets.findIndex(selectedFacet => selectedFacet.id === facetValueId) > -1;
        }
    }
}
</script>
